import React from 'react';

import { Icon } from '@iq/react-components';
import { SEVERITIES, DELIVERY_OPTIONS, SEVERITY_ICONS, SEVERITY_COLORS } from '../../constants';

const ExpansionRow = ({ settings, prefix, spacers }) => (
  <>
    {SEVERITIES.map((state) => {
      const setting = settings[state];
      const enabled = setting?.app || setting?.email;
      const activeDelivery = [];
      if (setting?.app) activeDelivery.push('app');
      if (setting?.email) activeDelivery.push('email');

      return (
        <div
          key={state}
          className={`${prefix}__row`}
        >
          {spacers.before.map(([width, cls]) => (
            <div
              key={cls}
              className={`${prefix}__spacer ${cls}`}
              style={{ width, flexShrink: 0 }}
            />
          ))}
          <div
            className={`${prefix}__onoff ${prefix}__col-onoff ${prefix}__onoff--${enabled ? 'on' : 'off'}`}
            style={spacers.onoffWidth ? { width: spacers.onoffWidth, flexShrink: 0 } : undefined}
          >
            <span>{enabled ? 'ON' : 'OFF'}</span>
          </div>
          <div className={`${prefix}__conditions ${prefix}__col-conditions`}>
            <div className={`${prefix}__state`}>
              <Icon
                icon={SEVERITY_ICONS[state]}
                size="s"
                color={SEVERITY_COLORS[state]}
              />
              <span>{state}</span>
            </div>
          </div>
          <div
            className={`${prefix}__delivery ${prefix}__col-delivery`}
            style={
              spacers.deliveryWidth ? { width: spacers.deliveryWidth, flexShrink: 0 } : undefined
            }
          >
            {!enabled || activeDelivery.length === 0 ? (
              <span className="delivery-tag delivery-tag--none">None</span>
            ) : (
              activeDelivery.map((opt) => {
                const label = DELIVERY_OPTIONS.find((d) => d.value === opt)?.label || opt;
                return (
                  <span
                    key={opt}
                    className="delivery-tag"
                  >
                    {label}
                  </span>
                );
              })
            )}
          </div>
          {spacers.after.map(([width, cls]) => (
            <div
              key={cls}
              className={`${prefix}__spacer ${cls}`}
              style={{ width, flexShrink: 0 }}
            />
          ))}
        </div>
      );
    })}
  </>
);

export default ExpansionRow;
